const INIT_STATE = {
   
    total_credits: 0,
    credits_limit: 10,
    used_credits_percentage: 0,
    plan_type: "basic",
    days_until_reset:30,
    duration_type: "monthly",
}
const creditsDataReducer = (state = INIT_STATE, action)=> {
    switch (action.type) {
        case 'SET_CREDITS_DATA':
            return action.payload 
        case 'RESET_CREDITS_DATA':
            return INIT_STATE
        default:
            return state
    }

}
export default creditsDataReducer